import { render, staticRenderFns } from "./messageManagement.vue?vue&type=template&id=d6b21b10&scoped=true&"
import script from "./messageManagement.vue?vue&type=script&lang=js&"
export * from "./messageManagement.vue?vue&type=script&lang=js&"
import style0 from "./messageManagement.vue?vue&type=style&index=0&id=d6b21b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b21b10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VFlex,VLayout,VTab,VTabItem,VTabs,VTabsItems})
